import { createFileRoute } from "@tanstack/react-router";
import { RouteError } from "../../../shared/components/RouteError";
import { RoutePending } from "../../../shared/components/RoutePending";

/**
 * @purpose Add a new bike model to the catalog
 * @primary Bike model form
 * @persona paola-admin-belora
 */
export const Route = createFileRoute("/app/c/$customerSlug/bike-models/new")({
  errorComponent: ({ error }) => <RouteError error={error} />,
  pendingComponent: RoutePending,
});
